import { createReducer, on } from '@ngrx/store';
import { loadFixedPagesFailure, loadFixedPagesSuccess } from './fixedPages.actions';
import { WpFixedPages } from '../../types/wordpress/common-data.type';
import { StoreState } from '../index';


export interface State extends StoreState {
  fixedPages?: WpFixedPages
}

export const initialState: State = {};

export const reducer = createReducer(
  initialState,
  on(loadFixedPagesSuccess, (state, {data}) => ({
    ...state,
    fixedPages: data,
    status: {...initialState.status, ready: true},
  })),
  on(loadFixedPagesFailure, (state, {error}) => ({...state, status: {loading: false, error, ready: true}})),
);

